import { fireStatusUpdate, Namespace } from '@chegg/commerce-utils';
import { transformErrorObjectToStatusUpdate } from './TransformUtils';

// ignoring this, as we cannot mock the fireStatusUpdate function for some reason
// TODO: will try again later after updating internal-tools SQUAA-312
/* istanbul ignore next */
var onError = function onError(error) {
  fireStatusUpdate(transformErrorObjectToStatusUpdate(error), Namespace.ONE_CLICK);
};
export default onError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/onError.js
// module id = 489
// module chunks = 11